import React from "react";
import {MarketStructList} from "../structs/MarketStructList";
import {MarketStruct} from "../structs/MarketStruct";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import {Link} from "react-router-dom";
import {BASE_URL_API, MARKET_BASE_URL_API} from "../Const";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// ✅ MUI core
import {Chip, IconButton,} from "@mui/material";
// ✅ MUI icons
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import CallRoundedIcon from "@mui/icons-material/CallRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import RoomRoundedIcon from "@mui/icons-material/RoomRounded";

export class MarketComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            marketList: [],
        }
    }


    componentDidMount() {

        let url = BASE_URL_API + 'markets';
        if (this.props.parent_category_id && this.props.parent_category_id !== -1) {
            url += '?parent_category_id=' + this.props.parent_category_id;
        }
        fetch(url, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    let data = new MarketStructList();

                    for (let i = 0; i < results.data.length; i++) {
                        if (data.marketList.length > 0) {
                            let size = data.marketList.length;
                            for (let j = 0; j < size; j++) {
                                if (results.data[i].category !== null && data.marketList[j].category === results.data[i].category.title) {
                                    data.marketList[j].marketList.push(results.data[i])

                                    break
                                } else {
                                    if (j === data.marketList.length - 1) {
                                        let marketStruct = new MarketStruct()
                                        marketStruct.category = results.data[i].category.title
                                        marketStruct.marketList.push(results.data[i])
                                        data.marketList.push(marketStruct)

                                    }
                                }
                            }
                        } else {
                            let marketStruct = new MarketStruct()
                            marketStruct.category = results.data[i].category.title
                            marketStruct.marketList.push(results.data[i])
                            data.marketList.push(marketStruct)
                        }


                    }

                    this.setState({marketList: data.marketList})
                },
                (error) => {
                    console.log("error")
                }
            );
    }

    render() {
        const MAX_LENGTH = 20;

        // 🧩 Helpers (place above your component or in a utils file)
        const formatTomans = (val) => {
            const n = Number(val || 0);
            if (!isFinite(n) || n <= 0) return "ارسال: نامشخص";
            return `ارسال: ${n.toLocaleString("fa-IR")} تومان`;
        };

        const isFilled = (v) =>
            v !== null && v !== undefined && String(v).trim() !== "" && String(v).toLowerCase() !== "none";

        // 🧱 UI (your horizontal scroller stays the same)

        return (
            this.state.marketList.map((marketGroup, index) => (
                <div key={index} style={{overflowX: 'hidden', overflowY: 'hidden', height: 300, marginBottom: 24}}>
                    <Grid container alignItems="center" style={{padding: '0 8px', direction: 'rtl'}}>
                        <Grid item xs={8} sm={10} md={10} lg={11}>
                            <strong style={{fontSize: 16}}>{marketGroup.category}</strong>
                        </Grid>
                        <Grid item xs={4} sm={2} md={2} lg={1} style={{textAlign: 'left'}}>
                            <Chip
                                label="مشاهده همه ›"
                                component="a"
                                href={`/market-list/?category_id=${marketGroup.marketList[0].category.id}`}
                                clickable
                                sx={{
                                    fontSize: 13,
                                    color: 'gray',
                                    backgroundColor: 'transparent',
                                    border: '1px solid #ccc',
                                    borderRadius: '8px',
                                    height: 26,
                                    px: 1.2,
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                        color: '#000',
                                        borderColor: '#999',
                                        backgroundColor: 'rgba(0,0,0,0.04)',
                                    },
                                }}
                            />

                        </Grid>
                    </Grid>


                    <List
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            overflowX: "auto",
                            overflowY: "hidden",
                            padding: "16px 8px",
                            margin: 0,
                            background: "transparent",
                            direction: "rtl",
                            gap: 8,
                        }}
                    >
                        {marketGroup.marketList.map((market) => (
                            <ListItem
                                key={market.id}
                                style={{width: 170, flexShrink: 0, padding: 0}}
                                component={Link}
                                to={`/market?id=${market.id}`}
                                sx={{textDecoration: "none", color: "inherit"}}
                            >
                                <Paper
                                    elevation={2}
                                    sx={{
                                        width: 150,
                                        borderRadius: 2,
                                        overflow: "hidden",
                                        bgcolor: "background.paper",
                                        transition: "transform .15s ease, box-shadow .15s ease",
                                        "&:hover": {transform: "translateY(-2px)", boxShadow: 4},
                                    }}
                                >
                                    {/* Image header with category tag */}
                                    <Box sx={{position: "relative", width: "100%", height: 110, bgcolor: "#f5f5f5"}}>
                                        <Box
                                            component="img"
                                            alt={market.name}
                                            src={
                                                market.pictures?.length > 0
                                                    ? MARKET_BASE_URL_API + market.pictures[0].url
                                                    : "hamekara-logo.png"
                                            }
                                            sx={{width: "100%", height: "100%", objectFit: "cover", display: "block"}}
                                        />
                                    </Box>

                                    {/* Body */}
                                    <Box sx={{px: 1, pt: 1, pb: 1}}>
                                        {/* Name */}
                                        <Typography
                                            sx={{
                                                fontSize: 13,
                                                fontWeight: 700,
                                                color: "text.primary",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                textAlign: "right",
                                                direction: "rtl",
                                            }}
                                            title={market.name}
                                        >
                                            {market.name}
                                        </Typography>

                                        {/* Rating + Shipping line */}
                                        <Box
                                            sx={{
                                                mt: 0.25,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                gap: 0.5,
                                            }}
                                        >
                                            {/* Rating (read-only) */}
                                            <Box sx={{display: "flex", alignItems: "center", gap: 0.3}}>
                                                <StarRoundedIcon sx={{fontSize: 16, color: "warning.main"}}/>
                                                <Typography sx={{fontSize: 12, color: "text.secondary"}}>
                                                    {Number(market.rate || 0).toFixed(1)}
                                                </Typography>
                                            </Box>

                                            {/* Shipping badge */}
                                            <Chip
                                                label={formatTomans(market.shipping)}
                                                size="small"
                                                sx={{
                                                    display: "inline-flex",
                                                    height: 22,
                                                    maxWidth: 90,
                                                    bgcolor: "grey.100",
                                                    color: "text.secondary",
                                                    "& .MuiChip-label": {
                                                        px: 0.75,
                                                        fontSize: 10.5,
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                    },
                                                }}
                                                title={formatTomans(market.shipping)}
                                            />
                                        </Box>

                                        {/* Optional address (one-line) */}
                                        {isFilled(market.address) && (
                                            <Typography
                                                sx={{
                                                    mt: 0.5,
                                                    fontSize: 11,
                                                    color: "text.secondary",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    textAlign: "right",
                                                }}
                                                title={market.address}
                                            >
                                                {market.address}
                                            </Typography>
                                        )}

                                        {/* Action row: phone / WhatsApp / Instagram / Map */}
                                        <Box
                                            sx={{
                                                mt: 0.75,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            {/* Phone */}
                                            {isFilled(market.tell) ? (
                                                <IconButton
                                                    size="small"
                                                    onClick={(e) => e.stopPropagation()}
                                                    component="a"
                                                    href={`tel:${market.tell}`}
                                                    aria-label="call"
                                                >
                                                    <CallRoundedIcon fontSize="small"/>
                                                </IconButton>
                                            ) : (
                                                <Box/>
                                            )}

                                            <Box sx={{display: "flex", alignItems: "center", gap: 0.5}}>
                                                {/* WhatsApp */}
                                                {isFilled(market.whatsapp) && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={(e) => e.stopPropagation()}
                                                        component="a"
                                                        href={`https://wa.me/${String(market.whatsapp).replace(/[^\d]/g, "")}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        aria-label="whatsapp"
                                                    >
                                                        <WhatsAppIcon fontSize="small"/>
                                                    </IconButton>
                                                )}

                                                {/* Instagram */}
                                                {isFilled(market.instagram) && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={(e) => e.stopPropagation()}
                                                        component="a"
                                                        href={`https://instagram.com/${String(market.instagram).replace(/^@/, "")}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        aria-label="instagram"
                                                    >
                                                        <InstagramIcon fontSize="small"/>
                                                    </IconButton>
                                                )}

                                                {/* Map / Directions */}
                                                {isFilled(market.lat) && isFilled(market.long) && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={(e) => e.stopPropagation()}
                                                        component="a"
                                                        href={`https://www.google.com/maps?q=${market.lat},${market.long}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        aria-label="map"
                                                    >
                                                        <RoomRoundedIcon fontSize="small"/>
                                                    </IconButton>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Paper>
                            </ListItem>
                        ))}
                    </List>

                </div>
            ))
        );


    }
}
